// extracted by mini-css-extract-plugin
export default {"codeTitle":"icdCode_codeTitle__VaTxx","subTitle":"icdCode_subTitle__vUiZI","table":"icdCode_table__TuLyI"};